import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import ApiRequest from 'client/helpers/apiRequest';
import { Homepage } from 'client/types/homepage';
import * as actions from './actions';

export const fetchHomepage = (): ThunkAction<Promise<any>, any, null, Action<string>> => dispatch => {
    dispatch(actions.fetchHomepageRequest());

    return ApiRequest.get<Homepage>('/api/homepage').then(
        (response = { filters: {} }) => dispatch(actions.fetchHomepageSuccess(response)),
        error => dispatch(actions.fetchHomepageError(error))
    );
};
